import React from 'react';
import { useAccessibility } from '../utils/accessibility';

interface AccessibleImageProps {
  src: string;
  altKey?: string;
  isDecorative?: boolean;
  className?: string;
  width?: number;
  height?: number;
  loading?: 'lazy' | 'eager';
  role?: string;
}

export const AccessibleImage: React.FC<AccessibleImageProps> = ({
  src,
  altKey,
  isDecorative = false,
  className = '',
  width,
  height,
  loading = 'lazy',
  role,
  ...props
}) => {
  const { getText } = useAccessibility();
  
  const imageProps = {
    src,
    className,
    width,
    height,
    loading,
    ...(isDecorative ? {
      alt: '',
      role: 'presentation',
      'aria-hidden': 'true'
    } : {
      alt: altKey ? getText(altKey) : '',
      role
    }),
    ...props
  };

  return <img {...imageProps} />;
};